module.exports = __webpack_public_path__ + "img/patient-record-desktop-en.de1d3c69.jpg";